import { render, staticRenderFns } from "./RelacaoProjeto.vue?vue&type=template&id=323ad624"
import script from "./RelacaoProjeto.vue?vue&type=script&lang=js"
export * from "./RelacaoProjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports